// @flow
import getLocalizedString from "./getLocalizedString";

export const sortCities = (cities, locale): Array<CityType> => {
  const getCityDisplayName = city => getLocalizedString("name", city, locale);
  const arr = cities ? [].concat(cities) : [];
  arr.sort((a, b) =>
    getCityDisplayName(a).localeCompare(getCityDisplayName(b), "fi")
  );
  return arr;
};



// WEBPACK FOOTER //
// ./src/utils/utils.js